module.exports = __webpack_public_path__ + "img/CRT_Bow 001.ec1fb647.png";